import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {DisplayBetween, DisplayCenter, HelpModalIcon, ModalTitle} from './StyledComponents';
import {DialogTitle} from '@mui/material';
import {GrClose} from 'react-icons/gr';
import {styled} from '@mui/material/styles';


export default function ModalDialog(props) {
    const ModalPopup = styled(Dialog)({
        '& .MuiDialog-paper': {
            borderRadius: '22px',
            overflow: props.helpModal ? "unset" : "auto"
        }
    })

    return (
        <div>
            <ModalPopup
                open={props.OpenModal}
                onClose={()=>{}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={props.size}
                fullWidth
            >
                <DialogTitle sx={{
                    px: 3,
                    pt: props.titlePadding === false ? 3 : 3,
                    pb: props.titlePadding === false ? 1 : props.helpModal ? 0 : 3
                }} id="alert-dialog-title">
                    {props.helpModal ?
                        <DisplayCenter>
                            <HelpModalIcon>
                                <img src="/images/activeHelp.png" width="40"/>
                            </HelpModalIcon>
                        </DisplayCenter>
                        : null
                    }
                    <DisplayBetween className={`${props.titlePadding === false ? "modal-btn" : ""}`}>
                        <ModalTitle>{props.title}</ModalTitle>
                        <div className='ml-10px'><GrClose onClick={props.CloseModal} style={{cursor: 'pointer'}}
                                                          size={15} color="#38485D"/></div>
                    </DisplayBetween>
                </DialogTitle>
                <DialogContent className="modal-style" sx={{px: props.defaultScroll ? 3 : 2, pt: 3}} style={{
                    overflow: `${props.defaultScroll ? "auto" : "hidden"}`,
                    paddingBottom: `${props.defaultScroll ? "auto" : "30px"}`
                }}>
                    {props.ModalContent}
                </DialogContent>
            </ModalPopup>
        </div>
    );
}